import { useContext,useRef, useEffect } from 'react'
import AuthContext from '../../Contexts/AuthenticationContext'
import TokenContext from '../../Contexts/TokenContext'
import axios from 'axios';
import Loader from '../../../genericComponents/Loader';
import { Box } from '@mui/material';
const AuthComponent = ({ children }) => {
  const auth = useContext(AuthContext)
  const token=useRef();
  
  const audience = process.env.REACT_APP_IDENTITY_AUDIENCE;
  const scope = 'openid profile email offline_access';

  const refreshToken = () => {
    return auth.getAccessTokenSilently({
      authorizationParams: { audience, scope },
    }).then(res => {
      token.current = res;
      console.log('Token refreshed successfully');
      console.log("New Token:", token.current);
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token.current;
      axios.defaults.headers.common['Content-Type'] = 'application/json';
      axios.defaults.headers.post['Content-Type'] = 'application/json';
      axios.defaults.headers.get['Content-Type'] = 'application/json';
    }).catch(err => {
      console.error('Token refresh failed:', err);
      
      // Handle errors gracefully
      if (err?.error === 'login_required' || 
          err?.error === 'consent_required' ||
          err?.message?.includes('Missing Refresh Token')) {
        console.log('Re-authentication required, redirecting...');
        auth.loginWithRedirect({ 
          authorizationParams: { audience, scope } 
        });
      }
    });
  };

  useEffect(() => {
    if (auth.isAuthenticated) {
      refreshToken();
      
      // Refresh token every 50 minutes (tokens usually expire after 1 hour)
      const interval = setInterval(() => {
        console.log('Auto-refreshing token...');
        refreshToken();
      }, 1000 * 60 * 50);
      
      return () => clearInterval(interval);
    }
  }, [auth.isAuthenticated]);

  if (!auth.isAuthenticated) {
    if (!auth.user && auth.isLoading) {      
      
      return (
        <Box sx={{height:'100vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
        <Loader text={"Authenticating..."} />        
      </Box>  
      )
    } else {
      if (!auth.error) {
        auth.loginWithRedirect({
          authorizationParams: { audience, scope }
        })
      } else {
        console.error('Auth error:', auth.error);
        
        // Retry login on error
        if (auth.error.message?.includes('Login required')) {
          auth.loginWithRedirect({
            authorizationParams: { audience, scope }
          });
        }
      }

      return (
        <Box sx={{height:'100vh',display:'flex',justifyContent:'center',alignItems:'center'}}>
          <Loader text={"Authenticating..."} />        
        </Box>
      )
    }
  }

  return <TokenContext.Provider value={token}> {children}</TokenContext.Provider>
}
export default AuthComponent
